import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import axios from "axios";
import bannerImage from "../../Images/about/award-b.webp";

const NewsEvents = () => {
    const [events, setEvents] = useState([]);
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState({
        events: true,
        news: true
    });

    const eventsBaseUrl = "https://isbmuniversity.edu.in/admin-portal/admin-assets/event-banners/";
    const newsBaseUrl = "https://isbmuniversity.edu.in/admin-portal/admin-assets/news-banners/";

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch events
                const eventsResponse = await axios.get("https://isbmuniversity.edu.in/admin-portal/eventApi");
                setEvents(eventsResponse.data.data || []);
                setLoading(prev => ({ ...prev, events: false }));

                // Fetch news
                const newsResponse = await axios.get("https://isbmuniversity.edu.in/admin-portal/newsApi");
                const newsData = newsResponse?.data?.data || [];
                const formattedNews = newsData.map(item => ({
                    id: item.id,
                    title: item.title,
                    banner: newsBaseUrl + item.banner,
                    description: item.description,
                    schedule: item.schedule || "News"
                }));
                setNews(formattedNews);
                setLoading(prev => ({ ...prev, news: false }));
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading({ events: false, news: false });
            }
        };

        fetchData();
    }, []);

    const ReadMore = ({ children }) => {
        const text = children;
        const [isReadMore, setIsReadMore] = useState(true);
        const toggleReadMore = () => setIsReadMore(!isReadMore);

        if (!text || text.length <= 100) return <p className="card-text">{text}</p>;

        return (
            <p className="card-text">
                {isReadMore ? text.slice(0, 100) + "..." : text}
                <span
                    onClick={toggleReadMore}
                    className="ms-2 text-blue fw-semibold"
                    style={{ cursor: "pointer", fontSize: "0.9rem" }}
                >
                    {isReadMore ? "Read More" : "Show Less"}
                </span>
            </p>
        );
    };

    const renderEventCards = () => (
        <Row className="row-cols-1 row-cols-md-3 row-cols-lg-4 g-4">
            {loading.events ? (
                <Col className="text-center">
                    <p>Loading events...</p>
                </Col>
            ) : events.length > 0 ? (
                events.map((event) => (
                    <Col key={event.id}>
                        <Card className="h-100 shadow border-0">
                            <Card.Img variant="top" src={eventsBaseUrl + event.banner} alt={event.title} />
                            <Card.Body>
                                <Card.Title className="fw-bold text-dark">{event.title}</Card.Title>
                                <ReadMore>{event.description}</ReadMore>
                            </Card.Body>
                            <Card.Footer>
                                <small className="text-muted">
                                    <i className="ti ti-calendar-event me-1"></i>
                                    Date: {event.schedule || "Event"}
                                </small>
                            </Card.Footer>
                        </Card>
                    </Col>
                ))
            ) : (
                <Col className="text-center">
                    <p>No events found at the moment.</p>
                </Col>
            )}
        </Row>
    );

    const renderNewsCards = () => (
        <Row className="row-cols-1 row-cols-md-3 row-cols-lg-4 g-4">
            {loading.news ? (
                <Col className="text-center">
                    <p>Loading news...</p>
                </Col>
            ) : news.length > 0 ? (
                news.map((item) => (
                    <Col key={item.id}>
                        <Card className="h-100 shadow border-0">
                            <Card.Img variant="top" src={item.banner} alt={item.title} />
                            <Card.Body>
                                <Card.Title className="fw-bold text-dark">{item.title}</Card.Title>
                                <ReadMore>{item.description}</ReadMore>
                            </Card.Body>
                            <Card.Footer>
                                <small className="text-muted">
                                    <i className="ti ti-calendar-event me-1"></i>
                                    Date: {item.schedule}
                                </small>
                            </Card.Footer>
                        </Card>
                    </Col>
                ))
            ) : (
                <Col className="text-center">
                    <p>No news found at the moment.</p>
                </Col>
            )}
        </Row>
    );

    return (
        <React.Fragment>
            <Topnav />

            {/* Hero Banner */}
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>News and Events</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>Home</a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    News and Events
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            {/* Intro Section */}
            <section className="awards-intro-section ptb-50 bg-white">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} className="text-center">
                            <h2 className="modern-title section-title text-blue">News & Events</h2>
                            <p className="lead text-blue">
                                Stay updated with the latest happenings at ISBM University – from academic conferences to student fests and important announcements.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Events and News (No Tabs) */}
            <section className="ptb-50 bg-light">
                <Container>
                    <h3 className="mb-4 text-center text-blue">Latest Events</h3>
                    {renderEventCards()}

                    <hr className="my-5" />

                    <h3 className="mb-4 text-center text-blue">Latest News</h3>
                    {renderNewsCards()}
                </Container>
            </section>

            <Footer />
        </React.Fragment>
    );
};

export default NewsEvents;
